// oxlint-disable no-useless-empty-export
import dayjs, { Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import arraySupport from 'dayjs/plugin/arraySupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import minMax from 'dayjs/plugin/minMax';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import dayjsBusinessDays from 'dayjs-business-days2';
import locales, { Locale } from './locales';
dayjs.extend(advancedFormat);
dayjs.extend(arraySupport);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(minMax);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(dayjsBusinessDays);
dayjs.extend(quarterOfYear);
export {} from 'dayjs/plugin/utc';
export {} from 'dayjs/plugin/isoWeek';
export {} from 'dayjs/plugin/isSameOrBefore';
export {} from 'dayjs/plugin/advancedFormat';
export {} from 'dayjs/plugin/arraySupport';
export {} from 'dayjs/plugin/customParseFormat';
export {} from 'dayjs/plugin/isBetween';
export {} from 'dayjs/plugin/isSameOrAfter';
export {} from 'dayjs/plugin/minMax';
export {} from 'dayjs/plugin/timezone';
export {} from 'dayjs/plugin/quarterOfYear';
export {} from 'dayjs-business-days2';
export {} from 'dayjs/plugin/relativeTime';
export { locales, Locale, Dayjs };
export default dayjs;
